package pwgs.ui.scenes.playerlogsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class APlayerLogsControllerFe(props: pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps, scene: MPlayerLogsScene)
 : AController<pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps, pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel, PlayerLogsSceneState>(props, scene) {

    val backend = PlayerLogsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_enableLogging() {
        launchOnDefaultControllerScope {
            render(backend.enableLogging())
        }
    }

    fun call_disableLogging() {
        launchOnDefaultControllerScope {
            render(backend.disableLogging())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class PlayerLogsControllerBeProxy(private val controller: APlayerLogsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerlogsscene.PlayerLogsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer())
        }
    }

    suspend fun enableLogging(): pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerlogsscene.PlayerLogsControllerBe.enableLogging",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer())
        }
    }

    suspend fun disableLogging(): pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerlogsscene.PlayerLogsControllerBe.disableLogging",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerlogsscene.PlayerLogsSceneModel.serializer())
        }
    }

}
